const SECOND_MS = 1000;

// Пересчет — чуть ПОСЛЕ границы секунды. Запас не дает задержке стать нулевой,
// когда остаток стоит ровно на границе (иначе пересчеты шли бы подряд без
// передышки), и к пересчету число на экране уже наверняка сменилось, даже если
// таймер браузера сработал на миллисекунду-другую раньше заказанного
const TICK_AFTER_BOUNDARY_MS = 20;

/**
 * Через сколько пересчитать таймер хода, чтобы число секунд на экране менялось
 * на границе секунды остатка, а ноль наступал вместе с вычисленным нулем.
 *
 * Секунды показываются округлением вверх (остаток 0,03 с — это «1 сек»).
 * Пересчет раз в секунду от произвольного момента держал бы такую «1 сек» на
 * экране почти целую секунду после настоящего нуля — и игрок кликал бы «на
 * последней секунде» по уже закрытому сервером ходу: отсрочка серверного
 * автозавершения (TURN_AUTO_END_GRACE_MS в ./turnTimeLimits) уходила бы на
 * запаздывание цифры.
 *
 * @param {number} remainingMs - остаток хода; отрицательный — срок прошел
 * @returns {number} задержка до следующего пересчета, больше нуля
 */
export const getMsToNextTurnTimerTick = (remainingMs) => {
  // Кривой остаток не должен превратить пересчет в бесконечный цикл
  if (!Number.isFinite(remainingMs)) {
    return SECOND_MS;
  }
  const msToSecondBoundary = ((remainingMs % SECOND_MS) + SECOND_MS) % SECOND_MS;
  return msToSecondBoundary + TICK_AFTER_BOUNDARY_MS;
};
